import { render, staticRenderFns } from "./turntable.vue?vue&type=template&id=22a1dd8a&scoped=true&"
import script from "./turntable.vue?vue&type=script&lang=js&"
export * from "./turntable.vue?vue&type=script&lang=js&"
import style0 from "./turntable.vue?vue&type=style&index=0&id=22a1dd8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a1dd8a",
  null
  
)

export default component.exports